import { Component, OnInit } from '@angular/core';
import { OtpVerifier } from "../../model/OtpVerifier";
import { UserService } from "../../services/user.service";
import { OtpService } from "../../services/otp.service";
import { OtpChannel } from "../../enum/OtpChannel";
import { firstValueFrom } from "rxjs";
import { Store } from "@ngrx/store";
import { UsersSelectors } from "../../../index";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SexyModule } from '@qid/sexy';
import { SuperButtonComponent, PageActionComponent } from '@qid/super';
import { ModalController, IonHeader, IonButton, IonToolbar, IonTitle, IonContent } from '@ionic/angular/standalone';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.page.html',
  styleUrls: ['./delete-account.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    PageActionComponent,
    IonHeader,
    IonButton,
    IonToolbar,
    IonTitle,
    IonContent
  ]
})
export class DeleteAccountPage implements OnInit {

  public otpVerifier: OtpVerifier = new OtpVerifier(OtpChannel.email);

  public user$ = this.store.select(UsersSelectors.selectAuthenticatedUser);

  constructor(private modalController: ModalController,
    private userService: UserService,
    private otpService: OtpService,
    private store: Store
  ) {
  }

  ngOnInit() {
  }

  cancel() {
    this.modalController.dismiss();
  }


  continueDelete = async () => {
    const user = await firstValueFrom(this.user$)

    this.otpVerifier.receiverId = user.email;

    if (!this.otpVerifier.receiverId || this.otpVerifier.receiverId.length < 1) {
      this.otpVerifier.channel = OtpChannel.phone;
      this.otpVerifier.receiverId = user.phoneNumber
    }

    await this.userService.checkEmail(user.email)

    this.otpVerifier = await this.otpService.sendAndVerify(this.otpVerifier);
    if (!this.otpVerifier.isVerified) {
      return;
    }

    const response: any = await this.userService.delete(this.otpVerifier)

    if (response && response.deleted) {
      this.modalController.dismiss({ isDeleted: true })
    }
  };


}
